export default __webpack_public_path__ + "static/media/cp_geo_dk.d83d2b98.svg";